export const TAGS = {
  ORDERS: 'Orders',
  ORDER: 'Order',
};
